var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value >0)?_c('v-sheet',{staticClass:"pa-2 px-4 mb-3 rounded",attrs:{"color":"primary","dark":""}},[_vm._v(" Вы можете снова отправить через 00:"+_vm._s(_vm.value.length === 1 ? ("0" + _vm.value) : _vm.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }